module.exports = __webpack_public_path__ + "static/media/chat.1d0b9a48.svg";